import IEventApi from '@/common/events/api/IEventApi';
import { Store } from 'vuex';
import { IRelaysChangedEvent, RelaysChangedEvent } from '@/common/apis/DeviceApi';
import store from '@/store';


export default function register(api: IEventApi) {
    api.onEvent<IRelaysChangedEvent>('RelaysChangedEvent', (t) => {
        store.commit('relays/loaded', {deviceNumber: t.deviceNumber, relays: t.relays});
    });
}
